var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnViewer = function SvgIcnViewer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.467c2.756 0 5.215 1.562 6.415 4.033-1.2 2.471-3.659 4.033-6.415 4.033-2.756 0-5.215-1.562-6.415-4.033C6.785 9.029 9.244 7.467 12 7.467ZM12 6c-3.636 0-6.742 2.28-8 5.5 1.258 3.22 4.364 5.5 8 5.5s6.742-2.28 8-5.5C18.742 8.28 15.636 6 12 6Zm0 3.667c1.004 0 1.818.821 1.818 1.833A1.826 1.826 0 0 1 12 13.333a1.826 1.826 0 0 1-1.818-1.833c0-1.012.814-1.833 1.818-1.833ZM12 8.2c-1.804 0-3.273 1.481-3.273 3.3 0 1.819 1.47 3.3 3.273 3.3 1.804 0 3.273-1.481 3.273-3.3 0-1.819-1.47-3.3-3.273-3.3Z",
    fill: "#292525"
  })));
};
export default SvgIcnViewer;